<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="sign_idfailed_block">
      <div class="body_inner">
        <div class="checkerroe_block">
          <div class="w-full flex items-center justify-center imgbox">
            <svg
              width="55"
              height="54"
              viewBox="0 0 55 54"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="width: 55px !important; height: 54px !important"
            >
              <path
                d="M27.5002 0.333496C12.7966 0.333496 0.833496 12.2966 0.833496 27.0002C0.833496 31.3673 1.98377 35.4466 3.84912 39.0861L0.958496 49.4377C0.285226 51.8422 2.66273 54.217 5.06787 53.5444L15.4246 50.6538C19.0616 52.5166 23.1361 53.6668 27.5002 53.6668C42.2038 53.6668 54.1668 41.7038 54.1668 27.0002C54.1668 12.2966 42.2038 0.333496 27.5002 0.333496ZM27.5002 4.3335C40.0419 4.3335 50.1668 14.4584 50.1668 27.0002C50.1668 39.5419 40.0419 49.6668 27.5002 49.6668C23.4962 49.6668 19.7565 48.6245 16.4924 46.8049C16.0315 46.5477 15.4876 46.4831 14.9793 46.6252L5.13037 49.3752L7.88037 39.5314C8.02243 39.0231 7.95785 38.4793 7.70068 38.0184C5.87837 34.7515 4.8335 31.0062 4.8335 27.0002C4.8335 14.4584 14.9584 4.3335 27.5002 4.3335ZM27.4689 12.3049C26.9389 12.3131 26.4339 12.5314 26.0648 12.9118C25.6956 13.2922 25.4926 13.8035 25.5002 14.3335V30.3335C25.4964 30.5985 25.5454 30.8616 25.6442 31.1076C25.743 31.3535 25.8898 31.5774 26.0758 31.7661C26.2619 31.9548 26.4837 32.1047 26.7282 32.207C26.9727 32.3093 27.2351 32.362 27.5002 32.362C27.7652 32.362 28.0276 32.3093 28.2721 32.207C28.5167 32.1047 28.7384 31.9548 28.9245 31.7661C29.1106 31.5774 29.2573 31.3535 29.3561 31.1076C29.4549 30.8616 29.5039 30.5985 29.5002 30.3335V14.3335C29.504 14.0658 29.4541 13.8001 29.3533 13.552C29.2526 13.304 29.103 13.0787 28.9136 12.8895C28.7242 12.7004 28.4987 12.5511 28.2506 12.4507C28.0024 12.3503 27.7366 12.3007 27.4689 12.3049ZM27.5002 36.3335C26.7929 36.3335 26.1146 36.6144 25.6145 37.1145C25.1144 37.6146 24.8335 38.2929 24.8335 39.0002C24.8335 39.7074 25.1144 40.3857 25.6145 40.8858C26.1146 41.3859 26.7929 41.6668 27.5002 41.6668C28.2074 41.6668 28.8857 41.3859 29.3858 40.8858C29.8859 40.3857 30.1668 39.7074 30.1668 39.0002C30.1668 38.2929 29.8859 37.6146 29.3858 37.1145C28.8857 36.6144 28.2074 36.3335 27.5002 36.3335Z"
                fill="#EE5B64"
              />
            </svg>
          </div>
          <h4>
            {{ $t("pages.error_page.heading") }}
          </h4>
          <p>
            {{ $t("pages.error_page.subHeading") }}
          </p>
          <p>
            {{ $t("pages.error_page.content") }}
          </p>
          <div class="action_block">
            <button
              class="
                w-full
                flex
                items-center
                justify-center
                btn_apply
                rounded-lg
                text-white
                btn_action
              "
              @click="$router.push({ name: 'RequestInformation' })"
            >
              {{ $t("pages.error_page.supportButton") }}
            </button>

            <button
              class="
                w-full
                flex
                items-center
                justify-center
                btn_apply
                rounded-lg
                text-white
                btn_goback
              "
              @click="$router.back()"
            >
              {{ $t("pages.error_page.backButton") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckLastnameFailed",
};
</script>

<style scoped>
.sign_idfailed_block {
  display: block;
  position: relative;
  margin: 80px 0 0;
}

.sign_idfailed_block h4 {
  font-size: 22px;
  text-align: center;
  width: 100%;
  color: #333333;
  font-weight: bold;
  margin: 0 0 15px;
}

.sign_idfailed_block p {
  color: #676666;
  text-align: center;
  font-size: 18px;
  font-weight: normal;
  font-weight: 500;
  margin: 0 0 15px;
}

.footer_main {
  display: none !important;
}

.sign_idfailed_block .checkerroe_block {
  display: block;
}

.sign_idfailed_block .checkerroe_block .imgbox {
  margin: 0 0 16px;
}

.sign_idfailed_block .action_block {
  width: 100%;
  margin: 80px 0 0;
}

.sign_idfailed_block .action_block button {
  margin-top: 10px;
  height: 44px;
  font-weight: 600;
}

.sign_idfailed_block .action_block .btn_goback {
  color: #63b15b !important;
  background: transparent !important;
}

.sign_idfailed_block .action_block .btn_facebook {
  color: #3b5998 !important;
  background: transparent !important;
  border: 0 !important;
}

.sign_idfailed_block .action_block .btn_facebook svg {
  margin-right: 8px;
}

/*-----------------------  Responsive code ------------------*/
/*-----------------------  Responsive code ------------------*/
@media only screen and (max-width: 767px) {
  .sign_idfailed_block h4 {
    font-size: 17px;
  }

  .sign_idfailed_block p {
    font-size: 14px;
  }
}

/*-----------------------  Responsive code ------------------*/
/*-----------------------  Responsive code ------------------*/
</style>
